export default [
  {
    title: 'Hệ thống',
    icon: { icon: 'tabler-settings' },
    permissionIds: [68, 73, 16, 11, 47, 52, 63, 1, 6, 26],
    children: [
      { title: 'QL client', to: { name: 'app-client', meta: { permissionId: 68 } } },
      { title: 'QL client product', to: { name: 'app-client-product', meta: { permissionId: 73 } } },
      { title: 'QL vị trí hình ảnh', to: { name: 'app-image-position', meta: { permissionId: 16 } } },
      { title: 'QL hình ảnh', to: { name: 'app-image', meta: { permissionId: 11 } } },
      { title: 'QL playlist', to: { name: 'app-playlist', meta: { permissionId: 47 } } },
      { title: 'QL video', to: { name: 'app-video', meta: { permissionId: 52 } } },
      { title: 'QL phòng máy', to: { name: 'app-location', meta: { permissionId: 63 } } },
      { title: 'QL quản trị viên', to: { name: 'app-admin', meta: { permissionId: 1 } } },
      {
        title: 'QL vai trò',
        to: { name: 'app-role', meta: { permissionId: 6, active: ['app-role-add', 'app-role-update-id'] } },
      },
      { title: 'Thêm mới vai trò', to: { name: 'app-role-add', meta: { permissionId: 8, hidden: true } } },
      {
        title: 'Cập nhật vai trò',
        to: { name: 'app-role-update-id', params: { id: 1 }, meta: { permissionId: 9, hidden: true } },
      },
      { title: 'Cài đặt', to: { name: 'app-setting', meta: { permissionId: 26 } } },
    ],
  },
]
